<template>
    <div>
        <div>
            <b-form-select v-model="selected" :options="options" class="select"></b-form-select>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {path} from '../../../config';
export default {
    name: 'targetGroup',
    created: async function() {
        await axios
            .get(`${path}levels`)
            .then(response => (
                this.levels = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
            this.setLevels();
    },
    updated: function(){
        this.$emit('sendLevel', this.selected)
    },
    methods: {
        setLevels: async function(){
            for(let item of this.levels){
                await this.options.push({value: item.level, text: item.level})
            }
        }
    },
    data: function(){
        return{
            selected: '',
            levels: '',
            options: [
                {value: '', disabled: true, text: 'Wybierz poziom'},
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
    .select {
        margin-bottom: 10px;
    }
</style>